<!-- Zweck: Stellt die HTML-Struktur für shop view result box compontent im Frontend bereit. -->
@if ((entries|async) && (entries|async)?.length > 0) {
  <div class="infoline">
    @if (infoText) {
      <div class="infobox">
        {{infoText}}
      </div>
    }
    @if ((viewcomp && viewcomp.show_warning|async)) {
      <div class="infobox warning">
        <svg-icon>warning</svg-icon>
        <div class="text">{{view.settings.warning_above_amount_text}}</div>
      </div>
    }
    <div class="addfieldbox">
      <view-field-selector label="Anzuzeigende Felder" class="tut_shopview_fields" [(fields)]="active_fields"
      [hidden_fields]="getHiddenFields()" (change)="updateView()"></view-field-selector>
    </div>
    <div style="clear: both"></div>
  </div>
  <div class="artikelboxholder" [class.mobile]="msvc.isMobile()|async">
    @for (artikel of entries|async; track trackByArtNr($index, artikel)) {
      <div class="artikelbox mat-elevation-z1"
        data-track-content
        [attr.data-content-name]="'Artikel '+(artikel.ArtikelName ? artikel.ArtikelName : artikel.ArtikelBezeichnung)+' ('+artikel.ArtikelNummer+')'">
        <div class="titlebox">
          <div class="underlined">
            <a routerLink="/shop/{{view.slug}}/{{artikel.ArtikelNummer}}">
              <span [class.highlightStrong]="artikel.AllreadyOrdered">
                <view-field-value-render [artikel]="artikel" [fieldname]="'ArtikelName'"
                mode="box" [nowrap]="false"></view-field-value-render>
              </span>
            </a>
            @if (cfg.domainconfig?.shop_aktionen_popup && artikel.ArtikelHatAktion && cfg.showShopAktionen(artikel)) {
              <artikel-aktionen-button [artikel]="artikel" [view]="view" [viewcomp]="viewcomp"
                [popupMode]="true"></artikel-aktionen-button>
            }
          </div>
        </div>
        <div class="innerbox">
          <table style="width: 100%">
            <tr>
              <td>
                <table style="width: 100%">
                  @for (fieldname of view_fields$|async; track trackByValue($index, fieldname)) {
                    <tbody [attr.data-content-piece]="fieldname">
                      @if (fieldname != 'ArtikelName') {
                        <tr>
                          <td style="vertical-align: top">
                            <b>
                              <view-field-label-render [fieldname]="fieldname" mode="box"></view-field-label-render>
                            </b>
                            <div style="position: relative; margin-top: -10px; display: inline-block">
                            </div>
                          </td>
                          <td style="vertical-align: top">
                            <view-field-value-render
                              [artikel]="artikel"
                              [fieldname]="fieldname"
                              [view]="view"
                              [viewcomp]="viewcomp"
                              [nowrap]="false"
                              mode="box"
                            ></view-field-value-render>
                            @if (fieldname == 'bezeichnung') {
                              <view-field-value-render
                                [artikel]="artikel"
                                [fieldname]="'note'"
                                [view]="view"
                                [viewcomp]="viewcomp"
                                mode="box"
                              >
                              </view-field-value-render>
                              @if (!cfg.domainconfig?.shop_aktionen_popup && !(view_fields$|async).includes('aktionen_button')) {
                                <view-field-value-render
                                  style="display: none"
                                  [artikel]="artikel"
                                  [fieldname]="'aktionen_button'"
                                  [view]="view"
                                  [viewcomp]="viewcomp"
                                  mode="box"
                                >
                                </view-field-value-render>
                              }
                              @if (!(view_fields$|async).includes('einkaufs_statistik_web_button')) {
                                <view-field-value-render
                                  style="display: none"
                                  [artikel]="artikel"
                                  [fieldname]="'einkaufs_statistik_web_button'"
                                  [view]="view"
                                  [viewcomp]="viewcomp"
                                  mode="box"
                                >
                                </view-field-value-render>
                              }
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  }
                </table>
              </td>
              <td style="width: 100px; text-align: center; vertical-align: top">
                <shop-view-action [viewcomp]="viewcomp" [artikel]="artikel" [view]="view"
                [row_mode]="true"></shop-view-action>
              </td>
            </tr>
          </table>
          @if (cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup && (visible_artikel_aktionen|async) && (visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
            <div
              style="background-color: white">
              <artikel-aktionen-details
                [aktionen]="(visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]"
                [directAddToWarenkorb]="!(view.settings && view.settings.bestellblock_mode) && !['NE', 'AV', 'NG'].includes(artikel.VerfuegbarkeitsstatusCode)">
              </artikel-aktionen-details>
            </div>
          }

          @if ((visible_artikel_einkaufsstatistik|async) && (visible_artikel_einkaufsstatistik|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
            <div
              style="background-color: white">
              <einkaufs-statitik-web-details [statistik]="artikel.EinkaufsStatistikWeb"></einkaufs-statitik-web-details>
            </div>
          }


        </div>
      </div>
    }
  </div>
}
